import { SvgStar06 } from '@bazaar-marketplace/assets/star-06';
import { rarityBadgeVariants } from '../collection-card';
import { getRarityName, getRarityVariant } from './utils';
import type { RarityBadgeProps } from './types';
import { cn } from '@bazaar-marketplace/utils';
import { useMemo } from 'react';
import type { CollectionResponseDtoRarity } from '~/lib/api';

export const RarityBadge = ({ rarity, className, textClassName, icon }: RarityBadgeProps) => {
  const rarityName = getRarityName(rarity);
  const variant = getRarityVariant(rarity);

  const isUppercasedRarity = useMemo(() => {
    const uppercasedRarity: CollectionResponseDtoRarity[] = ['ultimate', 'heirloom'];
    return uppercasedRarity.includes(rarity);
  }, [rarity]);

  const defaultIcon = useMemo(() => {
    if (isUppercasedRarity && !icon) {
      return <SvgStar06 className="size-4" />;
    }
    return icon ?? null;
  }, [isUppercasedRarity, icon]);

  const finalTextClassName = useMemo(
    () =>
      cn(
        'text-white py-1 rounded-[64px] px-2 text-sm font-bold whitespace-nowrap',
        isUppercasedRarity && 'uppercase',
        textClassName,
      ),
    [isUppercasedRarity, textClassName],
  );

  return (
    <div className={cn(rarityBadgeVariants({ rarity: variant }), className)}>
      {defaultIcon}
      <span className={finalTextClassName}>{rarityName}</span>
    </div>
  );
};
